import Proofs from 'project/containers/wrapup/proofs';
import FinalFiles from 'project/containers/wrapup/final_files';
import FinalName from 'project/containers/wrapup/final_name';
import Survey from 'project/containers/wrapup/survey';

/*
 * Definition of all possible wrapup steps.
 */
export const ALL_STEPS = [{
  name: 'approve_name',
  component: FinalName,
  title: {
    client: 'Approve Name',
    creative: 'Sign Contract',
  },
}, {
  name: 'approve_proofs',
  component: Proofs,
  title: {
    client: 'Proofs',
    creative: 'Proofs'
  },
}, {
  name: 'approve_files',
  component: FinalFiles,
  title: {
    client: 'Final Files',
    creative: 'Final Files'
  },
}, {
  name: 'survey',
  component: Survey,
  title: {
    client: 'Feedback',
    creative: 'Feedback'
  },
}];



// WEBPACK FOOTER //
// ./project/components/wrapup/all_steps.jsx